import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["filters", "products"]

    connect() {
    }

    filterChange(event) {
        const form = document.getElementById('collection-render-frm')
        if (form) {
            form.requestSubmit()
        }
    }

    removeFilter(event) {
        event.preventDefault()
        const tag = event.currentTarget.dataset.tag
        if (!tag) return

        const checkbox = document.getElementById(tag)
        if (checkbox) {
            checkbox.checked = false
            const form = document.getElementById('collection-render-frm')
            if (form) {
                form.requestSubmit()
            }
        }
    }
}
